import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TelerikScriptLoaderService {
  // Keyed by src/href so every caller across every component instance and every mount awaits the
  // same load instead of re-inserting the tag. A plain <script> tag re-executes every time it's
  // appended (unlike an ES module), so re-injecting jquery-3.7.1.min.js after the designer/viewer
  // widgets have already attached themselves to window.jQuery replaces $ with a pristine copy that
  // has no .ui/.telerikReportViewer/.telerik_WebReportDesigner methods on it.
  private readonly loadedScripts = new Map<string, Promise<void>>();
  private readonly loadedStyles = new Set<string>();

  loadScript(src: string): Promise<void> {
    let existing = this.loadedScripts.get(src);

    if (!existing) {
      existing = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.onload = () => resolve();
        s.onerror = reject;
        document.body.appendChild(s);
      });
      this.loadedScripts.set(src, existing);
    }

    return existing;
  }

  loadStyle(href: string): void {
    if (this.loadedStyles.has(href)) {
      return;
    }

    this.loadedStyles.add(href);

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }
}
